import React, { useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { AggregationState } from '../types'
import { Column, Columns, Details, Row, LastEvent } from '../styles'
import State from './state'
import Progress from './progress'

const Provider = styled.div`
    strong {
        text-transform: uppercase;
        color: var(--gray-800);
    }
`

const Expression = styled.pre`
    border: 1px solid #eee;
    padding: 4px;
`

const Error = styled.div`
    line-height: 44px;
    padding: 0 16px;
    border-top: 1px solid #eee;
    color: #d9534f;
`

const Info = styled(Error)`
    background: #eee;
    color: #333;
`

const Name = styled.span`
    font-size: 14px;
    font-weight: bold;
    color: var(--gray-700);
`
const EventType = styled(Name)`
    margin-left: 5px;
    font-size: 11px;
    font-weight: normal;
`

const Content = styled.div`
    border-top: 1px solid #eee;
    padding: 16px;
`

const Aggregation = ({
    aggregationState,
    toggleAggregation,
    selected,
    columns
}: {
    aggregationState: AggregationState
    toggleAggregation: Function
    selected: boolean
    columns: { [key: string]: number | string | undefined }[]
}) => {
    const [opened, toggleOpened] = useState<boolean>(false)

    return (
        !aggregationState.hidden && (
        <Row key={aggregationState.aggregationDefinition.id}>
            <Columns>
                <Column style={columns[0]}>
                    <input
                        type={'checkbox'}
                        onChange={(): void => toggleAggregation(aggregationState.aggregationDefinition.id)}
                        checked={selected}
                    />
                </Column>
                <Column style={columns[1]}>
                    <Name>
                        {aggregationState.aggregationDefinition.name}
                        <EventType>
                            ({aggregationState.assetEventType + aggregationState.aggregationDefinition.suffix})
                        </EventType>
                    </Name>
                </Column>

                <Column style={columns[2]}>
                    <LastEvent>
                        {aggregationState.lastUpdate > 0 ? (
                            <>
                                {moment(aggregationState.lastUpdate).format('DD/MM/YYYY HH:mm:ss')}
                                <span className="fromNow">({moment(aggregationState.lastUpdate).fromNow()})</span>
                            </>
                        ) : (
                            '--'
                        )}
                    </LastEvent>
                </Column>
                <Column style={columns[3]}>
                    <State aggregation={aggregationState} />
                </Column>
                <Column style={columns[4]}>
                    <a onClick={(): void => toggleOpened(e => !e)}>
                        <i className={'fa fa-chevron-down'} />
                    </a>
                </Column>
            </Columns>

            <Details>
                {aggregationState.progress ? (
                    <Progress {...aggregationState.progress} />
                ) : (
                    <div style={{ height: 4 }} />
                )}

                {opened ? (
                    <>
                        {aggregationState.state === 'ERROR' ? (
                            <Error>{aggregationState.message}</Error>
                        ) : (
                            <Info>
                                {aggregationState.message ||
                                    (aggregationState.progress
                                        ? aggregationState.progress.message
                                        : aggregationState.message)}
                            </Info>
                        )}
                        <Content>
                            <Provider>
                                <strong>Provider: </strong>
                                {aggregationState.aggregationDefinition.provider}
                            </Provider>
                            <Expression>
                                {aggregationState.aggregationDefinition.expression.replace(
                                    /{{eventType}}/g,
                                    aggregationState.inputEventType
                                )}
                            </Expression>

                            { (aggregationState.aggregationDefinition.indexes !== undefined && aggregationState.aggregationDefinition.indexes.length > 0) ? (
                            <>
                                <label className="control-label">Indexes:</label>
                                <ul>
                                    {aggregationState.aggregationDefinition.indexes.map((i: string[], j) => (
                                        <li key={j}>{JSON.stringify(i)}</li>
                                    ))}
                                </ul>
                            </>) : null }
                    </Content>
                    </>
                ) : null}
            </Details>
        </Row>
        )
    )
}

export default Aggregation
